export var DevicePlatform;
(function (DevicePlatform) {
    DevicePlatform["IOS"] = "ios";
    DevicePlatform["ANDROID"] = "android";
    DevicePlatform["WEB"] = "web";
    DevicePlatform["ELECTRON"] = "electron";
})(DevicePlatform || (DevicePlatform = {}));
//# sourceMappingURL=device-platform.const.js.map